var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('h1',[_vm._v(_vm._s(_vm.$t('pages.reset.title')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('pages.reset.explain')))]),_vm._v(" "),_c('reset-form',{attrs:{"token":_vm.token,"success_route":{ name: 'home' },"uri":"api/public/resetting/reset"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27fdf4b4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Authentification/reset.vue
// module id = 919
// module chunks = 1